import React, { useEffect, useRef, InputHTMLAttributes } from "react";
import { useField } from "@unform/core";
import { get } from "lodash";

import {
  CheckboxContainer,
  LabelText,
  LabelContainer,
  InputBox,
  InputVisual
} from "./styled-components";
import Icon from "../../_static/Icons";
import { tick } from "../../_static/Icons/icons";
import { white } from "../../_static/Colors";

const CheckboxInput = ({
  setChecked,
  onClick,
  name,
  label,
  id,
  value,
  qaLabel,
  isRadio,
  radioName,
  isRadioChecked,
  hasMarginBottom
}) => {
  const inputRef = useRef(null);
  const { fieldName, registerField, defaultValue } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      getValue(ref) {
        return ref.checked;
      },
      clearValue(ref) {
        // eslint-disable-next-line no-param-reassign
        ref.checked = false;
        setChecked(false);
      },
      setValue(ref, val) {
        if (val !== undefined) {
          // eslint-disable-next-line no-param-reassign
          ref.checked = val;
          setChecked(val);
        }
      }
    });
  }, [defaultValue, fieldName, registerField, inputRef.current]);

  const inputProps = isRadio
    ? { type: "radio", name: radioName, defaultChecked: isRadioChecked }
    : { type: "checkbox", defaultChecked: defaultValue };
  const isChecked =
    isRadioChecked !== undefined
      ? isRadioChecked
      : get(inputRef, "current.checked");

  return (
    <CheckboxContainer
      data-qa-label={qaLabel}
      hasMarginBottom={hasMarginBottom}
    >
      <LabelContainer htmlFor={id} key={id}>
        <InputBox
          ref={(ref) => {
            inputRef.current = ref;
          }}
          data-qa-label="input-visual"
          onChange={(e) => {
            setChecked(e.target.checked);
          }}
          onClick={onClick}
          value={value}
          id={id}
          {...inputProps}
        />
        <InputVisual isChecked={isChecked} isRadio={isRadio}>
          <Icon icon={tick} size={16} color={white.value} />
        </InputVisual>
        {!!label && <LabelText>{label}</LabelText>}
      </LabelContainer>
    </CheckboxContainer>
  );
};

CheckboxInput.defaultProps = {
  name: "defaultCheckboxName",
  setChecked: () => {},
  label: "",
  id: "",
  value: false,
  isRadio: false,
  radioName: "radio-group",
  hasMarginBottom: true
};

export default CheckboxInput;
